export default defineNuxtPlugin(async nuxtApp => {
	const token = useToken();
	const auth = useAuth();
	const route = useRoute();
	const webshop = useWebshop();
	const storage = useLocalStorage();

	if (!token.get()) {
		await token.generate();
	}

	const tasks = [];

	// Fetch abandonment data
	if (route.query.abandonment && route.query.saveconfirm) {
		tasks.push(
			webshop.fetchAbandonment({
				abandonment: route.query.abandonment,
				saveconfirm: route.query.saveconfirm,
			}),
		);
	}

	// Save gclid to localStorage (used for GTM purchase tracking)
	if (__GTM_TRACKING__ && route.query.gclid) {
		storage.create('nuxt:base:gclid', route.query.gclid, {raw: true});
	}

	// Save recommend.co tracking data to localStorage for persistence across redirects
	if (__RECOMMEND_TRACKING__ && route.query.rcmndref) {
		storage.create('nuxt:base:rcmndref', route.query.rcmndref, {raw: true});
	}

	// Handle user authentication
	if (__AUTH__) {
		const authTask = auth
			.fetchIsLogin()
			.then(async isLoggedin => {
				if (isLoggedin?.user_id) {
					await auth.fetchUser();
				}
			})
			.catch(e => {
				console.log('Auth error:', e);
			});
		tasks.push(authTask);
	}

	// Fetch cart data (making sure data is available to all pages and components)
	if (__WEBSHOP__ && !__WEBSHOP_INIT_CART_FROM_COMPONENT__) {
		tasks.push(webshop.fetchCart().catch(e => console.log('Fetching cart error:', e)));
	}

	await Promise.all(tasks);
});
